import { type AxiosError } from 'axios'
import { type UseMutationOptions } from 'react-query'

import type {
  DynatraceEntitySelectionAsEntityId,
  DynatraceEntitySelectionAsK8sTargeting
} from 'components/status-checks/status-checks-form-utils'
import type { TeamExternalIntegration } from 'types/api/status-checks/status-check'

export enum DynatracePreFlightErrorResponseStatus {
  DYNATRACE_NOT_FOUND = 'DYNATRACE_NOT_FOUND',
  DYNATRACE_BAD_REQUEST = 'DYNATRACE_BAD_REQUEST',
  GREMLIN_BAD_REQUEST = 'GREMLIN_BAD_REQUEST',
  GREMLIN_INTERNAL_EXCEPTION = 'GREMLIN_INTERNAL_EXCEPTION'
}

export type DynatraceK8sQuery = {
  clusterId: string
  kind: string
  name: string
  namespace: string
}

export type DynatraceEntityId = string
export interface DynatraceEntity {
  entityId: DynatraceEntityId
  displayName: string
  type: string
}

export type DynatracePreFlightExternalIntegration = Omit<
  TeamExternalIntegration,
  'type'
>

export interface DynatracePreFlightSuccessResponse {
  dynatraceEntities: {
    entities: DynatraceEntity[]
    totalCount: number
  }
  status: string
}

export interface DynatracePreFlightErrorResponse {
  errorMessage: string
  status: DynatracePreFlightErrorResponseStatus
}

export type DynatracePreFlightResponse =
  | DynatracePreFlightSuccessResponse
  | DynatracePreFlightErrorResponse

export type DynatracePreFlightPayload = {
  teamExternalIntegrationReference: DynatracePreFlightExternalIntegration
} & (
  | Omit<DynatraceEntitySelectionAsEntityId, 'type'>
  | Omit<DynatraceEntitySelectionAsK8sTargeting, 'type'>
)

export type DynatracePreFlightParams = DynatracePreFlightPayload & {
  signal?: AbortController['signal']
}

export type UseDynatracePreFlightOptions = Omit<
  UseMutationOptions<
    DynatracePreFlightSuccessResponse,
    AxiosError<DynatracePreFlightErrorResponse>,
    DynatracePreFlightParams
  >,
  'mutationKey' | 'mutationFn'
>
